import paddyField from "@/api/paddy-fields";

export default {
  state: {
    paddyFields: [],
    paddyField: {},
  },
  mutations: {
    ["RETRIEVE_PADDY_FIELDS"](state, data) {
      state.paddyFields = data;
    },
    ["SHOW_PADDY_FIELD"](state, data) {
      state.paddyField = data;
    },
  },
  actions: {
    async retrievePaddyFields(context, management_id = null) {
      try {
        if (management_id == null) {
          management_id = await context.dispatch("showManagementID");
        }
        let params = {
          management_id: management_id,
        }
        let res = await paddyField.index(params);
        context.commit("RETRIEVE_PADDY_FIELDS", res.data.data);
      } catch (error) {
        console.log(error);
      }
    },
    async showPaddyField(context, id) {
      try {
        let params = {
          management_id: await context.dispatch("showManagementID"),
          paddy_field_id: id
        }
        let res = await paddyField.show(params);
        context.commit("SHOW_PADDY_FIELD", res.data.data[0]);
      } catch (error) {
        console.log(error);
      }
    },
    async insertPaddyFields(context, latLongs) {
      try {
        let management_id = await context.dispatch("showManagementID");
        for (const pos of latLongs) {
          let param = {
            management_id: management_id,
            map_pos: pos,
          }
          await paddyField.bulkCreate(param);
        }
        //TODO commit?
      } catch (error) {
        // TODO
        alert("登録に失敗しました。");
        console.log(error);
        throw error;
      }
    },
    async updatePaddyField(context, params) {
      try {
        params.management_id = await context.dispatch("showManagementID");
        await paddyField.update(params);
        //TODO commit?
      } catch (error) {
        // TODO
        alert("更新に失敗しました。");
        console.log(error);
        throw error;
      }
    },
    async deletePaddyField(context, params) {
      try {
        params.management_id = await context.dispatch("showManagementID");
        await paddyField.del(params);
      } catch (error) {
        alert("削除に失敗しました。");
        console.log(error);
        throw error;
      }
    },
  },
  getters: {
    getPaddyFields(state) {
      return state.paddyFields;
    },
    getPaddyField(state) {
      return state.paddyField;
    },
  },
};
